






















import Vue, { PropType } from 'vue';
import { v4 } from 'uuid';

export default Vue.extend({
  name: 'GAuthPasswordUnderlineForm',
  props: {
    value: { type: String as PropType<string>, required: true },
    label: { type: String as PropType<string>, required: true },
    placeholder: { type: String as PropType<string>, default: '' },
    name: { type: String as PropType<string>, required: true },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    maxlength: { type: Number as PropType<number>, required: true },
    rules: { type: [String, Object] as PropType<string | object>, default: '' },
  },
  computed: {
    vid(): string {
      return `${this.name}:${v4()}`;
    },
    innerValue: {
      get(): string {
        return this.value;
      },
      set(val: string): void {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    validate() {
      (this.$refs.gAuthPasswordUnderlineFormProvider as any).validate();
    },
  },
});
